import { ReactElement } from 'react';
import Grid from '@mui/material/Grid';
import { SxProps } from '@mui/system/styleFunctionSx';
import { LeftPositionedRow } from 'components/flex-containers';

interface Props {
  columns: number;
  elements: ReactElement[];
  sx?: SxProps;
}

export const GridLayout = ({ columns, elements, sx }: Props) => {
  return (
    <LeftPositionedRow spacing={1} sx={sx}>
      {elements.map(element => (
        <Grid key={element.key} item xs={12 / columns}>
          {element}
        </Grid>
      ))}
    </LeftPositionedRow>
  );
};
